<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Bizonylat áthelyezések</span>
      <el-button
        v-can="'receipttransfer.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/representative-processes/receipt-transfers/add')"
      >
        Új áthelyezés
      </el-button>
    </div>
    <div
      v-loading="loading"
      style="min-height: 81px;"
    >
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="receiptTransfer/fetchAll"
      />
    </div>
    <receipt-transfer-list />
    <template v-if="$route.meta.showAddReceiptTransferDialog">
      <receipt-transfer-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateReceiptTransferDialog">
      <receipt-transfer-dialog
        :receipt-transfer-id="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import receiptTransferList from '../../components/representativeProcesses/receiptTransfers/List';
  import receiptTransferDialog
    from '../../components/representativeProcesses/receiptTransfers/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      receiptTransferList,
      receiptTransferDialog,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let storages = this.$store.getters['storage/storages'];
        if (!storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/storages'];
        }
        let transferTypes = [
          {
            label: 'Manuális',
            value: 1
          },
          {
            label: 'Automatikus',
            value: 2
          }
        ]
        this.filterConfig = [
          {
            type: 'select',
            name: 'source_storage',
            options: storages,
            label: 'Forrás raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
            defaultSearch: true,
          },
          {
            type: 'select',
            name: 'target_storage',
            options: storages,
            label: 'Cél raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'type',
            options: transferTypes,
            label: 'Típus',
            labelCallback: type => type && type.label || '',
            valueKey: 'value',
          },
        ];
      },
    },
  };
</script>
